"use client";

import { HopperThemingProvider } from "@hopper-b2b/hopper-theming";
import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import { OutageBanner } from "../../lib";

const CONTROL = "Control";
const AVAILABLE = "Available";

function parseFlag(flag: string) {
  try {
    if (flag) return JSON.parse(flag);
  } catch (e) {
    console.error("Error parsing OutageBanner flag:", e);
  }
  return {
    name: CONTROL,
    text: "",
  };
}

const BannerRoot = () => {
  const flags = useFlags<{ outageBanner: string }>();
  const outageBanner = parseFlag(flags.outageBanner);

  // We ignore the text since it is not internationalized
  return outageBanner?.name === AVAILABLE ? (
    <HopperThemingProvider enableHDSTheme>
      <OutageBanner />
    </HopperThemingProvider>
  ) : null;
};

export const LDOutageBanner = (props: { clientSideID: string }) => {
  // Memoize the provider component to avoid creating it during render
  // LaunchDarkly HOC pattern requires this dynamic provider creation
  const LDProvider = useMemo(
    () =>
      // eslint-disable-next-line react-hooks/static-components
      withLDProvider({
        clientSideID: props.clientSideID,
        context: {
          kind: "user",
          anonymous: true,
          platform: "web",
          key: "00000000-0000-0000-0000-000000000000",
        },
        options: {
          streaming: false,
        },
        flags: {
          OutageBanner: "{}",
        },
      })(BannerRoot),
    [props.clientSideID]
  );

  // eslint-disable-next-line react-hooks/static-components
  return <LDProvider />;
};
